export const isOrderCancelled = ({ salesOrder }) => {
    return salesOrder.global_sales_order_status === 'fully-cancelled'
};

export default {};